import React, { useContext } from "react";
import PropTypes from "prop-types";
import { ClipLoader } from "react-spinners";


const OverlayLoading = ({
  isLoading,
  children,
  loaderColor = "#01265d",
  loaderSize = 40,
}) => {
 

  // Adjust overlay color based on theme
  const overlayBackgroundColor = "rgb(0 0 0 / 32%)";

  return (
    <>
      {children}
      {isLoading && (
        <div
          style={{
            position: "absolute", // Position it within the modal container
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: overlayBackgroundColor,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999, // Ensure the loader appears above other content
          }}
        >
          <ClipLoader
          className="loader_clip"
            color={loaderColor}
            loading={isLoading}
            size={loaderSize}
          />
        </div>
      )}
    </>
  );
};

OverlayLoading.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  loaderColor: PropTypes.string,
  loaderSize: PropTypes.number,
};

export default OverlayLoading;
